import { useEffect } from 'react'
import { useSearch } from '@faststore/sdk'
import type { IStoreSelectedFacet } from '@faststore/api'
import QuickFilterButton from 'src/components/sections/ProductGalleryV2/filters/QuickFilterButton'
import { TruckShippingIcon } from 'src/components/Icons/TruckShippingIcon'
import { LightningIcon } from 'src/components/Icons/FilterIcons/LightningIcon'
import { useAddressContext } from 'src/components/checkout/steps/shipping/context/address-context'
import { hasQuickFilters } from 'src/utils/plp/QuickFilters'

import type { Facet } from '../types'

type DeliveryDateProps = {
  facet: Facet
  onChange: (value: IStoreSelectedFacet) => void
}

export function DeliveryDate({ facet, onChange }: Readonly<DeliveryDateProps>) {
  const { postalCode } = useAddressContext()
  const {
    state: { selectedFacets },
    setFacets,
  } = useSearch()

  const hasValues = facet?.values && facet.values.length > 0

  const stringFacets = selectedFacets
    .map(
      (filter: { key: string; value: string }) =>
        `${filter.key}=${filter.value}`
    )
    .join(',')

  const quickFiltersIsApplied = hasQuickFilters(stringFacets)

  useEffect(() => {
    if (!quickFiltersIsApplied) {
      const facetsWithoutDelivery = selectedFacets.filter(
        (filter) => filter.key !== facet.key
      )

      setFacets(facetsWithoutDelivery)
    }
  }, [selectedFacets, facet.key, quickFiltersIsApplied, setFacets])

  if (!postalCode || !hasValues) {
    return null
  }

  return (
    <div
      className="flex flex-col gap-4 py-4 border-b border-gray"
      data-testid="delivery-date-filter"
    >
      <span className="flex items-center gap-2 text-base text-restructure-primary font-medium font-inter text-left leading-[21px]">
        <TruckShippingIcon />
        {facet.name}
      </span>
      <div className="w-full flex flex-row items-center justify-start">
        <div className="flex gap-2 flex-1 flex-wrap">
          {facet.values.map((facetValue) => (
            <div className="relative" key={facetValue.value}>
              <span className="-top-1 left-0 absolute rounded-full px-2 bg-redDiscount text-white text-[10px]">
                Novo
              </span>
              <QuickFilterButton
                key={facetValue.value}
                facetKey={facetValue.key ?? facet.key}
                facetValue={facetValue}
                onClick={onChange}
                label={facetValue.label}
                Icon={LightningIcon}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
